import { useLoaderData } from "@remix-run/react";

import type { LandingPageLoader } from "~/routes/_pages._index";

import type { FeaturesSectionProps } from "./FeaturesSction";
import Features from "./FeaturesSction";
import type { GrowSectionProps } from "./GrowSection";
import GrowSection from "./GrowSection";
import type { IntroSectionProps } from "./IntroSection";
import IntroSection from "./IntroSection";
import type { PricingSectionProps } from "./PricingSection";
import PricingSection from "./PricingSection";
import type { TestimonialSectionProps } from "./TestimonialSection";
import TestimonialSection from "./TestimonialSection";

const Sections = () => {
  const {
    page: { sections },
  } = useLoaderData<LandingPageLoader>();

  return (
    <>
      {sections.map((section) => {
        switch (section?.type) {
          case "IntroSection":
            return (
              <IntroSection
                key={section.id}
                {...(section as IntroSectionProps)}
              />
            );
          case "FeatureSection":
            return (
              <Features
                key={section.id}
                {...(section as FeaturesSectionProps)}
              />
            );
          case "PricingSection":
            return (
              <PricingSection
                key={section.id}
                {...(section as PricingSectionProps)}
              />
            );
          case "GrowSection":
            return (
              <GrowSection
                key={section.id}
                {...(section as GrowSectionProps)}
              />
            );
          case "TestimonialSection":
            return (
              <TestimonialSection
                key={section.id}
                {...(section as TestimonialSectionProps)}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
};

export default Sections;
